import { ReactElement } from 'react';
import cx from 'clsx';
import { useField } from 'react-final-form';
import { Box, Icon, vars } from '@ff-it/ui';
import {
  searchInput,
  searchInputClear,
  searchInputField,
  searchInputFieldActive,
  searchInputIcon,
  searchInputIconActive,
} from './SearchFilterInput.css';

export function SearchFilterInput({
  name = 'search',
  placeholder = 'Search…',
}: {
  name?: string;
  placeholder?: string;
}): ReactElement {
  const { input } = useField<string>(name, { subscription: { value: true } });
  const active = !!input.value;
  const width = `calc(${Math.max(placeholder.length, 20)}ch + ${vars.space['6']} + 1.5rem)`;

  return (
    <Box as="span" className={searchInput}>
      <Icon icon="magnifying-glass" className={cx(searchInputIcon, active && searchInputIconActive)} />
      <input
        className={cx(searchInputField, active && searchInputFieldActive)}
        style={{ width }}
        placeholder={placeholder}
        value={input.value || ''}
        onChange={(e) => input.onChange(e.target.value)}
      />
      {active && (
        <Box as="button" type="button" className={searchInputClear} onClick={() => input.onChange('')}>
          <Icon icon="xmark" size="md" />
        </Box>
      )}
    </Box>
  );
}
